import { render, staticRenderFns } from "./DeclaracaoAtendimento.vue?vue&type=template&id=78155f38&scoped=true"
import script from "./DeclaracaoAtendimento.vue?vue&type=script&lang=js"
export * from "./DeclaracaoAtendimento.vue?vue&type=script&lang=js"
import style0 from "./DeclaracaoAtendimento.vue?vue&type=style&index=0&id=78155f38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78155f38",
  null
  
)

export default component.exports